// Central source-of-truth for legal business identity.
// All values are env-driven so they can be updated without a code change.
// Fields left blank are hidden from the UI automatically.

const e = (v) => (v && v.trim() ? v.trim() : '');

export const LEGAL_BUSINESS_NAME = e(process.env.REACT_APP_LEGAL_BUSINESS_NAME) || 'MusicSync';
export const LEGAL_PAN = e(process.env.REACT_APP_LEGAL_PAN);
export const LEGAL_GSTIN = e(process.env.REACT_APP_LEGAL_GSTIN);
export const LEGAL_ADDRESS = e(process.env.REACT_APP_LEGAL_ADDRESS);
export const LEGAL_EMAIL = 'admin@musicsync.net';
